var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 481,
    height: 63,
    viewBox: "0 0 481 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5V0.5C156.449 24.3651 315.592 24.6424 472.124 1.32235L481 0L318.5 63H125.5L0 0.5Z",
    fill: "url(#paint0_linear_783_6182)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_783_6182",
    x1: 72.5,
    y1: 52.5,
    x2: 383.5,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0087C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleicon);
export default __webpack_public_path__ + "static/media/rectangle.icon.d1acc46929530eb266144c551d67d24d.svg";
export { ForwardRef as ReactComponent };